export const getIsFeeChangeEditable = ({ feeChange, isEditAllowed }) =>
  isEditAllowed && !!feeChange.editable;

export const getHasEditableFeeChanges = ({ feeChanges, isEditAllowed }) =>
  feeChanges.some(feeChange => getIsFeeChangeEditable({ feeChange, isEditAllowed }));
